export function createDataWorker(): Worker {
  return new Worker(new URL('./worker.worker', import.meta.url));
}